import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

import SideContentBlock from "../../shared/sideContentBlock";
import SideContentInner from "../../shared/sideContentInner";
import ReportViewBlock from "./ReportViewBlock";
import SelectedCarsList from "../sections/reports/selectedCarsList";
import DownloadReportsModal from "../sections/reports/downloadReportsModal";
import ReportContentTitle from "../sections/reports/reportTools";

import styles from "./reportPage.module.scss";

class ReportPage extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <React.Fragment>
        <Scrollbars style={{ height: "100%" }} autoHide={true}>
          <div className={styles.reportPage}>
            <div className={styles.reportPage_container}>
              <SideContentBlock>
                <SideContentInner>
                  <ReportContentTitle />
                  <SelectedCarsList />
                  <ReportViewBlock />
                </SideContentInner>
              </SideContentBlock>
            </div>
          </div>
        </Scrollbars>
        <DownloadReportsModal />
        {/*   <SavingReportsModal />
    <SavingReportMessages />
    <DownloadReportsModal />
    <DownloadReportMessages /> */}
      </React.Fragment>
    );
  }
}

export default ReportPage;
